import {
  Box,
  createStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
  Chip,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import BACKGROUND from "assets/img/bg_manager_student.png";
import { withStyles } from "@material-ui/styles";
import { Pagination } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import useStyles from "./style";
import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import { AccessLogList, ListResponseAccessLog } from "models/managerUser";
import { ListParams } from "models/common";
import managerUserApi from "api/managerUser";
import EmptyComponent from "components/Empty";
import InputSearch from "components/InputSearch";
import ComputerIcon from "@material-ui/icons/Computer";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import TabletIcon from "@material-ui/icons/Tablet";
import DevicesIcon from "@material-ui/icons/Devices";

export interface AccessHistoryProps { }
export default function AccessHistory(props: AccessHistoryProps) {
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "16px 5px",
        color: "#1B1B1B",
        fontSize: 11,
        fontWeight: 700,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid #777777",
        top: "0 !important",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
      body: {
        padding: "16px 5px",
        fontSize: 11,
        borderRight: "1px solid rgba(224, 224, 224, 0.8)",
        [theme.breakpoints?.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const { t } = useTranslation();
  const [logAccess, setLogAccess] = useState<any>();
  const [filter, setFilter] = useState<ListParams>({ page: 0, size: 10, name: "" });
  const [isSticky, setIsSticky] = useState(false);
  const classes = useStyles({
    background: BACKGROUND,
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollContainer = containerRef.current?.closest("main");
    if (!scrollContainer) return;

    const handleScroll = () => {
      if (scrollContainer.scrollTop > 120) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const targetParents: HTMLElement[] = [];
    const originalOverflows: string[] = [];

    if (containerRef.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent.tagName !== "MAIN") {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflow === "hidden" ||
          computedStyle.overflowX === "hidden" ||
          computedStyle.overflowY === "hidden"
        ) {
          targetParents.push(parent);
          originalOverflows.push(parent.style.overflow);
          parent.style.overflow = "visible";
        }
        parent = parent.parentElement;
      }
    }

    return () => {
      targetParents.forEach((parent, index) => {
        if (parent) {
          parent.style.overflow = originalOverflows[index];
        }
      });
    };
  }, [logAccess]);

  const getAccessLog = async (currentFilter: ListParams) => {
    try {
      const searchValue = (currentFilter.name || currentFilter.name_like || "").trim();
      let params = {
        page: currentFilter.page || 0,
        size: 10,
        name: searchValue,
        name_like: searchValue,
      };
      const res: ListResponseAccessLog<AccessLogList> = await managerUserApi.getAccessLog(params);
      if (res.responseCode === "00") {
        setLogAccess(res);
      }
    } catch (error) { }
  };

  const handleChangePage = (page: number) => {
    setFilter((prev) => ({ ...prev, page: page - 1 }));
  };

  const handleSearchChange = (newFilter: ListParams) => {
    setFilter((prev) => ({
      ...prev,
      page: 0,
      name: newFilter.name,
      name_like: newFilter.name_like,
    }));
  };

  useEffect(() => {
    getAccessLog(filter);
  }, [filter]);

  const logsList: any[] = logAccess?.accessLogList || [];
  const totalElements = logAccess?.pageInfo?.totalElements ?? logsList.length;
  const totalPages = logAccess?.pageInfo?.totalPages ?? Math.ceil(totalElements / 10);

  const getFormattedTime = (accessTimestamp: any) => {
    if (!accessTimestamp) return "---";
    const date = new Date(accessTimestamp);
    if (isNaN(date.getTime())) return "---";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hour = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hour}:${minutes} - ${day}/${month}/${year}`;
  };

  const renderDeviceBadge = (deviceStr: string) => {
    const str = (deviceStr || "").toLowerCase();
    let icon = <DevicesIcon style={{ color: "#475569", fontSize: 18 }} />;
    let bgColor = "#F1F5F9";
    let textColor = "#334155";
    let label = deviceStr || "Chưa xác định";

    if (str.includes("mobile") || str.includes("phone") || str.includes("iphone") || str.includes("android")) {
      icon = <SmartphoneIcon style={{ color: "#059669", fontSize: 18 }} />;
      bgColor = "#ECFDF5";
      textColor = "#047857";
    } else if (str.includes("tablet") || str.includes("ipad")) {
      icon = <TabletIcon style={{ color: "#D97706", fontSize: 18 }} />;
      bgColor = "#FFFBEB";
      textColor = "#B45309";
    } else if (str.includes("desktop") || str.includes("laptop") || str.includes("web") || str.includes("mac") || str.includes("windows") || str.includes("pc")) {
      icon = <ComputerIcon style={{ color: "#2563EB", fontSize: 18 }} />;
      bgColor = "#EFF6FF";
      textColor = "#1D4ED8";
    }

    return (
      <Box style={{ display: "inline-flex", alignItems: "center", gap: 6, backgroundColor: bgColor, padding: "4px 12px", borderRadius: 8 }}>
        {icon}
        <Typography style={{ fontSize: "0.8125rem", fontWeight: 700, color: textColor }}>
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <div ref={containerRef} className={classes.root}>
      <Box className={classes.background}>
        <Typography variant="subtitle2"> {t("admin.listitem.lichsutruycap")}</Typography>
      </Box>

      {/* Sticky Filter Toolbar */}
      <Box className={clsx(classes.filterToolbar, isSticky && classes.stickyActive)}>
        <Box style={{ width: isMobile ? "100%" : 360 }}>
          <InputSearch
            filter={filter}
            onSearchChange={handleSearchChange}
            label={t("managerStudent.timkiemhocvientheoten")}
          />
        </Box>
      </Box>

      {logsList.length > 0 ? (
        <>
          <TableContainer style={{ margin: "20px 0" }} className={classes.container} component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" width="20px">
                    {t("managerStudent.register.stt")}
                  </StyledTableCell>
                  <StyledTableCell align="left" width="140px">
                    {t("managerStudent.accesshistory.hoten")}
                  </StyledTableCell>
                  <StyledTableCell align="left" width="90px">
                    {t("managerStudent.accesshistory.manhanvien")}
                  </StyledTableCell>
                  <StyledTableCell align="left" width="120px">
                    {t("managerStudent.accesshistory.truycapgannhat")}
                  </StyledTableCell>
                  <StyledTableCell align="left" width="120px">
                    {t("managerStudent.accesshistory.thietbi")}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logsList.map((item: any, index: number) => (
                  <TableRow key={index} hover>
                    <StyledTableCell align="center" component="th" scope="user">
                      {(filter.page || 0) * 10 + index + 1}
                    </StyledTableCell>
                    <StyledTableCell align="left" style={{ paddingLeft: 12 }}>
                      <Typography style={{ fontWeight: 800, color: "#0F172A", fontSize: "0.875rem" }}>
                        {item?.user?.name || "---"}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left" style={{ paddingLeft: 12 }}>
                      <Chip
                        label={item?.user?.staffId || "---"}
                        size="small"
                        style={{ backgroundColor: "#F1F5F9", color: "#334155", fontWeight: 700, borderRadius: 6 }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" style={{ paddingLeft: 12 }}>
                      <Typography style={{ fontWeight: 600, color: "#334155", fontSize: "0.8125rem" }}>
                        {getFormattedTime(item?.accessTimestamp)}
                      </Typography>
                    </StyledTableCell>
                    <StyledTableCell align="left" style={{ paddingLeft: 12 }}>
                      {renderDeviceBadge(item?.device)}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Mobile View: ListView */}
          {isMobile && (
            <Box className={classes.mobileListView}>
              {logsList.map((item: any, index: number) => (
                <Box key={index} className={classes.mobileCard}>
                  {/* Card Header: STT & Name */}
                  <Box className={classes.mobileCardHeader}>
                    <Box>
                      <Typography variant="subtitle2" style={{ fontWeight: 800, color: "#0F172A" }}>
                        {item?.user?.name || "---"}
                      </Typography>
                      <Typography variant="caption" style={{ color: "#64748B" }}>
                        STT: {(filter.page || 0) * 10 + index + 1}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Card Body: Info group */}
                  <Box className={classes.mobileCardBody}>
                    <Box className={classes.mobileCardRow}>
                      <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                        MÃ NHÂN VIÊN
                      </Typography>
                      <Chip
                        label={item?.user?.staffId || "---"}
                        size="small"
                        style={{
                          backgroundColor: "#E2E8F0",
                          color: "#334155",
                          fontWeight: 700,
                          borderRadius: 6,
                        }}
                      />
                    </Box>

                    <Box className={classes.mobileCardRow}>
                      <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                        TRUY CẬP GẦN NHẤT
                      </Typography>
                      <Typography variant="caption" style={{ fontWeight: 600, color: "#334155" }}>
                        {getFormattedTime(item?.accessTimestamp)}
                      </Typography>
                    </Box>

                    <Box className={classes.mobileCardRow}>
                      <Typography variant="caption" style={{ color: "#64748B", fontWeight: 700 }}>
                        THIẾT BỊ
                      </Typography>
                      {renderDeviceBadge(item?.device)}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </>
      ) : (
        <EmptyComponent isBorder={false} />
      )}

      {totalElements > 0 && (
        <Box className={classes.paginationContainer}>
          <Typography variant="subtitle2" style={{ fontWeight: 600 }}>
            {t("managerStudent.tongcong")}: {totalElements}
          </Typography>
          {totalPages > 1 && (
            <Pagination
              count={totalPages}
              page={(filter.page || 0) + 1}
              variant="outlined"
              color="primary"
              shape="rounded"
              size={isMobile ? "small" : "medium"}
              siblingCount={isMobile ? 0 : 1}
              onChange={(e, page) => handleChangePage(page)}
            />
          )}
        </Box>
      )}
    </div>
  );
}

